<template>
	<span class="text-h6 text-sm-h5">
		امروز: {{ today }}
	</span>
</template>

<script>
	export default {
		name: 'Today',
		data() {
			return {
				today: ''
			}
		},
		mounted() {
			this.today = new Date().toLocaleDateString('fa-IR')
		},
	}
</script>
